/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TrackAddedToPurchasedAlbumNotificationActionData
 */
export interface TrackAddedToPurchasedAlbumNotificationActionData {
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPurchasedAlbumNotificationActionData
     */
    trackId: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPurchasedAlbumNotificationActionData
     */
    playlistId: string;
    /**
     * 
     * @type {string}
     * @memberof TrackAddedToPurchasedAlbumNotificationActionData
     */
    playlistOwnerId: string;
}

/**
 * Check if a given object implements the TrackAddedToPurchasedAlbumNotificationActionData interface.
 */
export function instanceOfTrackAddedToPurchasedAlbumNotificationActionData(value: object): value is TrackAddedToPurchasedAlbumNotificationActionData {
    let isInstance = true;
    isInstance = isInstance && "trackId" in value && value["trackId"] !== undefined;
    isInstance = isInstance && "playlistId" in value && value["playlistId"] !== undefined;
    isInstance = isInstance && "playlistOwnerId" in value && value["playlistOwnerId"] !== undefined;

    return isInstance;
}

export function TrackAddedToPurchasedAlbumNotificationActionDataFromJSON(json: any): TrackAddedToPurchasedAlbumNotificationActionData {
    return TrackAddedToPurchasedAlbumNotificationActionDataFromJSONTyped(json, false);
}

export function TrackAddedToPurchasedAlbumNotificationActionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): TrackAddedToPurchasedAlbumNotificationActionData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'trackId': json['track_id'],
        'playlistId': json['playlist_id'],
        'playlistOwnerId': json['playlist_owner_id'],
    };
}

export function TrackAddedToPurchasedAlbumNotificationActionDataToJSON(value?: TrackAddedToPurchasedAlbumNotificationActionData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'track_id': value.trackId,
        'playlist_id': value.playlistId,
        'playlist_owner_id': value.playlistOwnerId,
    };
}

